import React from 'react';
import Tooltip from '@/components/mui/Tooltip';

import CancelIcon from '@mui/icons-material/Cancel';

const RejectedStatus = ({ status }) => {
  const isRejected = status.includes('rejected');
  const t = {
    id: 'tooltip.rejected',
    defaultMessage: 'Rejected',
  };

  return (
    isRejected && (
      <Tooltip t={t} placement="top">
        <CancelIcon sx={{ fontSize: 20, color: 'error.main' }} />
      </Tooltip>
    )
  );
};

export default RejectedStatus;
